import React, { useEffect, useState } from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar/DateCalendar';
// import { DemoContainer } from '@mui/x-date-pickers'

import './calendar.css';
import { DateField } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import CaliList from './caliList';


const Calender = () => {
  // const [cal, setCal] = useState([])
  const displayShrinks = useMediaQuery('(max-width:769px)');
  const location = useLocation();
  
  // useEffect(() => {
  //   const fetchCals = async () => {
  //     try{
  //        const result = await fetch('http://localhost:5000/api/books')
  //       const resultData = await result.json()
  //       setCal(resultData)
  //       console.log('cal:', resultData)
  //     } catch(err) {
  //       console.error(err.message)
  //     }
     
  //   }
  //    fetchCals();
  // },[])
   const [caleData, setCaleData] = useState([]);

    useEffect(() => {
        const fetchCaleData = async () => {
            try {
                const result = await fetch(process.env.REACT_APP_BACKEND_URL + '/cali')
                const responseData = await result.json();

                setCaleData(responseData);
                console.log('Calendar data: ', responseData)
            } catch(err){
              console.error('Could not fetch calendar data - frontend', err.message)
            }
        }
        fetchCaleData();
    }, []);


  const [selectedDate, setSelectedDate] = useState(null)

  const handleChange = (date) => {
    setSelectedDate(date)
  }

  // const UniMonth = [...new Set(caleData.map(c => {c.month_name, c.bilig_day}))]

  if (location.pathname === '/'){
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {displayShrinks ? (
          <DateField
            label="controlled field"
            defaultValue={dayjs()}
            format='LL'      
            sx={{margin: '36px', padding: '0px'}}
          /> 
          ) : (
          <DateCalendar 
            value={selectedDate}
            onChange={handleChange}
            label="Today"
            sx={{
              display: 'flex', width: '100%',
            }}  
 
          /> 
        )
        }
   
      </LocalizationProvider>
  )
  } else {
    return (
      // <LocalizationProvider dateAdapter={AdapterDayjs}>
      //     <DateCalendar 
      //       defaultValue={dayjs()}   
      //     />   
          
      // </LocalizationProvider>32
      <div style={{}}> 
        <h1>Монгол цаг тоолол</h1>
        { 
        caleData.map((c, i) => { 
          const today = new Date().toLocaleDateString('en-CA');     // хэдний өдрийг харуулах
          const datePart = c.western_date.split('T')[0]         // Огноо форматыг засах
          const isToday = datePart === today;


          return isToday ? (
       
            <h3 key={i} style={{textAlign: 'start'}}>
              {c.month_name} 
              
            </h3>  
  
          ) : null;         
         })}
       
        <CaliList cale={caleData}/>
      </div>
      
    )
  }
  
}
export default Calender;